<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>礼品卡回收说明</h2>
					<div class="help-cont">
						<p class="">2、当选择的面值与实际面值不一致时，您将损失差额，而且会造成延迟到账，请正确选择；</p>
						<p class="">3、转让成功前请不要丢弃实体卡；</p>
						<p class="">4、您的账号因自身原因礼品卡被盗取或封存导致不能审核的责任由您自己承担，我们将直接撤单；</p>
						<p class="">5、若您重复提交同一卡号或故意提交错误信息的，我们会取消交易，并冻结您的账户信息；</p>
						<p class="">6、如果您私下将礼品卡信息交易给其他买家，并再次出售给本网站，造成的损失由您承担，我们将对您的账户信息进行冻结处理；</p>
						<p class="">7、礼品卡交易在未给您打款期间出现问题的话，您应积极配合解决问题，根据要求我们将延迟打款，如果问题没有解决我们将按责任轻重来加以处理；</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

			

<script>
import leftAbout from '../common/about/index.vue'
export default{
	data(){
		return{
			
		}
	},
	components:{
		leftAbout
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/declrea.vue